export default class Product {
    constructor(dom) {
      this.productUID = '';
      this.dom = dom;
      this.customPartCanvas = '';
      this.variation_cart = '';
    }
    init(){
        this.initProductPostObject();
        // this.initProductDetailsColorOpt();
    }
    initProductPostObject(){
        let tmpPath = '?www_api=1&cmd=get_product';
        fetch(tmpPath)
        .then((response) => response.json())
        .then((data) => {
            if(data.product_uid){
                this.productUID = data.product_uid;
                this.initProductDetailsColorOpt();
            }
        });
        this.variation_cart = document.querySelector("form.variations_form.cart");
        if(this.variation_cart){
            this.var_cart_timeout = undefined;
            this.variation_cart.addEventListener("change", (event) => {
                clearTimeout(this.var_cart_timeout);
                this.timeoutID = setTimeout(()=>{
                        this.updateVariationSlide();
                    }, 100);
            });
        }
    }

    updateVariationSlide(){
        if(this.variation_cart){
            let tmp_preset_id = this.variation_cart.getAttribute('current-image');
            if(tmp_preset_id){
                let variation_event = new CustomEvent("handleProductDetailsSlider", {
                    detail: {
                    type: 'slideTo',
                    value: tmp_preset_id
                    }
                });
                document.dispatchEvent(variation_event);
            }
        }
    }


    initProductDetailsColorOpt() {
        const detailsPage = document.querySelector(".product-info-details");
        const items = document.querySelectorAll("[js-pd-color-opt]");
        if (detailsPage && items) {
            let selectedEl;
            for (let item of items) {
                item.addEventListener("click", (e) => {
                    e.preventDefault();
                    selectedEl && selectedEl.classList.remove("selected");
                    // selectedEl = e.target;
                    selectedEl = item;
                    item.classList.add("selected");
                    let tmp_preset = item.getAttribute('data-preset');
                    let tmp_preset_id = item.getAttribute('data-preset_id');
                    if(tmp_preset_id){

                        const event = new CustomEvent("handleProductDetailsSlider", {
                          detail: {
                            type: 'slideTo',
                            value: tmp_preset_id
                          }
                        });
                        document.dispatchEvent(event);

                        let tmpItems = document.querySelectorAll("[js-pd-color-opt]");
                        for (let tmpItem of tmpItems) {
                            let _tmp_preset_id = tmpItem.getAttribute('data-preset_id');
                            if(_tmp_preset_id==tmp_preset_id){
                                tmpItem.classList.add("selected");
                                let actionbuttons = document.querySelectorAll("button.btn.btn-go");
                                for(let actionbtn of actionbuttons){
                                    actionbtn.disabled = false;
                                }
                                let presetValues = document.querySelectorAll("input[name=custom_preset]");

                                for(let presetValue of presetValues){
                                    presetValue.value = tmp_preset_id;
                                }
                            }else{
                                tmpItem.classList.remove("selected");
                            }
                        }
                    }

                    if(tmp_preset && tmp_preset_id && this.productUID){
                        let customObj = JSON.parse(tmp_preset);
                        this.changeWooAddOnsConfig(customObj);
                    }
                });
            }

            let actionbuttons = document.querySelectorAll("button.btn.btn-go, button.btn.btn-mega");
            for(let actionbtn of actionbuttons){
                let tmpTarget = actionbtn.getAttribute('data-target');
                if(tmpTarget=='addtocart'){
                    actionbtn.addEventListener('click', (e)=>{
                        document.querySelector(".single_add_to_cart_button").click();
                    });
                }
            }

        }
    }
    changeWooAddOnsConfig(customObj){
        // console.log(customObj);
        if(this.productUID==customObj.productUID && customObj.isValid){
            // console.log('initChange');
            let customOptionWrapper = document.querySelector('.page-wrapper').getAttribute('data-target_class');
            let customsummaryfeild = document.querySelector('.'+customOptionWrapper+' textarea.wc-pao-addon-field');
            
            // console.log(customsummaryfeild);
            if(customsummaryfeild){

                customsummaryfeild.value = JSON.stringify(customObj);
                if(customObj.productPartsOptions){
                    for (let  tmpOpt of customObj.productPartsOptions){
                        let textureCatOpt = tmpOpt.typeCategoryID;
                        if(textureCatOpt){
                            let optUID = tmpOpt.uid;
                            let partOptName = '.wc-pao-addon.wc-pao-addon'+optUID.substring(customObj.productUID.length);
                            let selectFeild = document.querySelector(partOptName+' .wc-pao-addon-field');
                            let tmpCatOpt = textureCatOpt.split("texture-");
                            if(selectFeild && tmpCatOpt[1]){
                                let tmpoptions = Array.from(selectFeild.options);
                                let optionToSelect = tmpoptions.find(item => item.dataset.label ===tmpCatOpt[1]);
                                if(optionToSelect){
                                    optionToSelect.selected = true;
                                }
                            }
                        }

                    }
                }
                if(customObj.stamping.content!=''){
                    let targetClass =  document.querySelector('.page-wrapper').getAttribute('data-stamping_class');
                    if( document.querySelector('.'+targetClass) ){
                        let configInStr = customObj.stamping;
                        document.querySelector('.'+targetClass+' input').value = JSON.stringify(configInStr);
                    }
                }
                
            }
        }
    }
}
